function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import { orders as ordersService } from "../../services";
import { contacts as contactsService } from "../../services";
export var init = function init(signers) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(dispatch, getState) {
      var _getState, module, stack, initialized;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _getState = getState(), module = _getState.module;
            stack = module.settings.stack;
            dispatch({
              type: 'ORDER_INITIALIZE_REQUEST'
            });
            _context.prev = 3;
            _context.next = 6;
            return ordersService.init(stack, signers);
          case 6:
            initialized = _context.sent;
            dispatch({
              type: 'ORDER_INITIALIZE_SUCCESS',
              order: initialized
            });
            return _context.abrupt("return", initialized);
          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](3);
            _context.t0.statusCode === 403 ? dispatch({
              type: 'ORDER_PERMISSION_DENIED'
            }) : dispatch({
              type: 'ORDER_INITIALIZE_FAILURE'
            });
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[3, 11]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
export var getIdps = function getIdps(signMechanism) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(dispatch, getState) {
      var state, stack, signMechanismSetting, idps;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            state = getState();
            stack = state.create.data.advanced.stack;
            signMechanismSetting = state.create.data.uiFeatures.signMechanismSetting;
            if (!(!signMechanism && signMechanismSetting === 'choose_every_time')) {
              _context2.next = 6;
              break;
            }
            dispatch({
              type: 'ORDER_SET_AVAILABLE_IDPS',
              idps: null
            });
            return _context2.abrupt("return", null);
          case 6:
            _context2.prev = 6;
            _context2.next = 9;
            return ordersService.getIdps(stack, signMechanism || signMechanismSetting);
          case 9:
            idps = _context2.sent;
            dispatch({
              type: 'ORDER_SET_AVAILABLE_IDPS',
              idps: idps
            });
            return _context2.abrupt("return", idps);
          case 14:
            _context2.prev = 14;
            _context2.t0 = _context2["catch"](6);
            dispatch({
              type: 'ORDER_SET_AVAILABLE_IDPS',
              idps: null
            });
            return _context2.abrupt("return", null);
          case 18:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[6, 14]]);
    }));
    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();
};
export var getByIdFromStoreOrApi = function getByIdFromStoreOrApi(id) {
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(dispatch, getState) {
      var _state$orders, _state$orders$data, state, order;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            dispatch({
              type: 'ORDER_INITIALIZE_REQUEST'
            });
            state = getState(); // eslint-disable-next-line no-underscore-dangle
            _context3.t0 = state === null || state === void 0 ? void 0 : (_state$orders = state.orders) === null || _state$orders === void 0 ? void 0 : (_state$orders$data = _state$orders.data) === null || _state$orders$data === void 0 ? void 0 : _state$orders$data.find(function (o) {
              return o.id === id && o._lastFetchedById;
            });
            if (_context3.t0) {
              _context3.next = 8;
              break;
            }
            _context3.next = 7;
            return ordersService.getById(id);
          case 7:
            _context3.t0 = _context3.sent;
          case 8:
            order = _context3.t0;
            dispatch({
              type: 'ORDER_INITIALIZE_SUCCESS',
              order: order
            });
            return _context3.abrupt("return", order);
          case 13:
            _context3.prev = 13;
            _context3.t1 = _context3["catch"](0);
            _context3.t1.statusCode === 403 ? dispatch({
              type: 'ORDER_PERMISSION_DENIED'
            }) : console.error(_context3.t1);
          case 16:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[0, 13]]);
    }));
    return function (_x5, _x6) {
      return _ref3.apply(this, arguments);
    };
  }();
};
export var getById = function getById(id) {
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(dispatch, getState) {
      var order;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            dispatch({
              type: 'ORDER_INITIALIZE_REQUEST'
            });
            _context4.next = 3;
            return ordersService.getById(id);
          case 3:
            order = _context4.sent;
            dispatch({
              type: 'ORDER_INITIALIZE_SUCCESS',
              order: order
            });
            return _context4.abrupt("return", order);
          case 6:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function (_x7, _x8) {
      return _ref4.apply(this, arguments);
    };
  }();
};
export var createAndSend = function createAndSend() {
  return /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(dispatch, getState) {
      var _getState2, create, signersForContacts, _iterator, _step, signer;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _getState2 = getState(), create = _getState2.create;
            signersForContacts = create.data.signers.filter(function (s) {
              var _s$data$addons;
              return (_s$data$addons = s.data.addons) === null || _s$data$addons === void 0 ? void 0 : _s$data$addons.addToContacts;
            });
            if (!contactsService) {
              _context5.next = 26;
              break;
            }
            _iterator = _createForOfIteratorHelper(signersForContacts);
            _context5.prev = 4;
            _iterator.s();
          case 6:
            if ((_step = _iterator.n()).done) {
              _context5.next = 18;
              break;
            }
            signer = _step.value;
            _context5.prev = 8;
            _context5.next = 11;
            return contactsService.createContact({
              companyName: signer.data.companyName,
              email: signer.data.email,
              firstName: signer.data.firstName,
              jobTitle: signer.data.companyRole,
              lastName: signer.data.lastName,
              mobileNumber: signer.data.mobile
            });
          case 11:
            _context5.next = 16;
            break;
          case 13:
            _context5.prev = 13;
            _context5.t0 = _context5["catch"](8);
            console.error(_context5.t0);
          case 16:
            _context5.next = 6;
            break;
          case 18:
            _context5.next = 23;
            break;
          case 20:
            _context5.prev = 20;
            _context5.t1 = _context5["catch"](4);
            _iterator.e(_context5.t1);
          case 23:
            _context5.prev = 23;
            _iterator.f();
            return _context5.finish(23);
          case 26:
            return _context5.abrupt("return", dispatch(save()).then(function (order) {
              return ordersService.send(create.data);
            }));
          case 27:
          case "end":
            return _context5.stop();
        }
      }, _callee5, null, [[4, 20, 23, 26], [8, 13]]);
    }));
    return function (_x9, _x10) {
      return _ref5.apply(this, arguments);
    };
  }();
};
export var save = function save() {
  return /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(dispatch, getState) {
      var _getState3, create;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return dispatch(refreshEtag());
          case 2:
            _getState3 = getState(), create = _getState3.create;
            return _context6.abrupt("return", ordersService.save(create.data).then(function (order) {
              dispatch({
                type: 'ORDER_SAVE_SUCCESS',
                order: order
              });
            }));
          case 4:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    return function (_x11, _x12) {
      return _ref6.apply(this, arguments);
    };
  }();
};
export var refresh = function refresh() {};
export var refreshEtag = function refreshEtag() {
  return /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(dispatch, getState) {
      var _getState4, create;
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            _getState4 = getState(), create = _getState4.create;
            return _context7.abrupt("return", ordersService.head(create.data.id).then(function (headers) {
              return headers.get('etag');
            }).then(function (etag) {
              return dispatch({
                type: 'SET_ETAG',
                etag: etag
              });
            }));
          case 2:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    return function (_x13, _x14) {
      return _ref7.apply(this, arguments);
    };
  }();
};
export var send = function send() {
  return /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(dispatch) {
      return _regeneratorRuntime().wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }));
    return function (_x15) {
      return _ref8.apply(this, arguments);
    };
  }();
};
export var addSigner = function addSigner() {
  return /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(dispatch) {
      return _regeneratorRuntime().wrap(function _callee9$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
          case "end":
            return _context9.stop();
        }
      }, _callee9);
    }));
    return function (_x16) {
      return _ref9.apply(this, arguments);
    };
  }();
};
export var updateSigner = function updateSigner() {};
export var removeSigner = function removeSigner() {};
export var setSignatureMethod = function setSignatureMethod() {};
export var setPrivate = function setPrivate(priv) {
  return function (dispatch, getState) {
    var _getState5 = getState(),
      session = _getState5.session;
    var user = session.user;
    var userId = user.userId;
    if (priv === true) {
      return dispatch({
        type: 'ORDER_SET_PERMISSIONS_USERS',
        users: [userId]
      });
    } else {
      return dispatch({
        type: 'ORDER_SET_PERMISSIONS_USERS',
        users: null
      });
    }
  };
};
export var removeFile = function removeFile(file) {
  var getActionType = function getActionType(category) {
    switch (category) {
      case 'attachment':
        return 'ADD_ATTACHMENT';
      case 'document':
        return 'ADD_DOCUMENT';
      default:
        throw new Error('Unknown type');
        return null;
    }
  };
  var actionType = getActionType(category);
  return {
    type: actionType,
    file: file
  };
};
export var categorizeFile = function categorizeFile(file, category) {
  var getActionType = function getActionType(category) {
    switch (category) {
      case 'attachment':
        return 'ADD_ATTACHMENT';
      case 'document':
        return 'ADD_DOCUMENT';
      default:
        throw new Error('Unknown type');
        return null;
    }
  };
  var actionType = getActionType(category);
  return {
    type: actionType,
    file: file
  };
};
export var editFile = function editFile(orderId, fileId, parameter, value) {
  return /*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(dispatch) {
      var order;
      return _regeneratorRuntime().wrap(function _callee10$(_context10) {
        while (1) switch (_context10.prev = _context10.next) {
          case 0:
            _context10.next = 2;
            return ordersService.editFile(orderId, fileId, parameter, value);
          case 2:
            order = _context10.sent;
            return _context10.abrupt("return", dispatch({
              type: 'ORDER_EDIT',
              order: order
            }));
          case 4:
          case "end":
            return _context10.stop();
        }
      }, _callee10);
    }));
    return function (_x17) {
      return _ref10.apply(this, arguments);
    };
  }();
};
export default {
  save: save,
  createAndSend: createAndSend,
  init: init,
  getById: getById,
  getByIdFromStoreOrApi: getByIdFromStoreOrApi,
  send: send,
  addSigner: addSigner,
  updateSigner: updateSigner,
  removeSigner: removeSigner,
  setSignatureMethod: setSignatureMethod,
  setPrivate: setPrivate,
  removeFile: removeFile,
  editFile: editFile,
  categorizeFile: categorizeFile,
  refresh: refresh,
  refreshEtag: refreshEtag,
  getIdps: getIdps
};